import { Dropdown } from '@delmonicos/shared-design-system-react/src/components/dropdown/dropdown';
import { useTranslation } from 'react-i18next';

import { getDcVoltageOptions } from '../helper/connector-dc.helper';

interface PhysicalSocketDcVoltageProps {
  value?: number | '';
  required?: boolean;
  errorMessage?: string;
  onChange: (value: number | '') => void;
}

// Stand-in for the free voltage input of a DC connector: only the values Gireve accepts.
export const PhysicalSocketDcVoltage = ({
  value,
  required,
  errorMessage,
  onChange,
}: PhysicalSocketDcVoltageProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dropdown
      label={t('delmonicos-shared-sdk.outputs-physical-socket.voltage')}
      placeholder={t('delmonicos-shared-sdk.outputs-physical-socket.voltage')}
      required={required}
      errorMessage={errorMessage}
      value={value === undefined || value === '' ? undefined : `${value}`}
      onChange={(selected) => onChange(selected ? Number(selected) : '')}>
      {getDcVoltageOptions(value).map((voltage) => (
        <Dropdown.Option key={voltage} value={`${voltage}`}>
          {voltage}
        </Dropdown.Option>
      ))}
    </Dropdown>
  );
};
